<div class="modal-box add-task-modal"
    [class.add-task-modal--dropdown-open]="dropdownOpen"
    [class.add-task-modal--dropdown-expanded]="dropdownExpansion > 0"
    [style.--dropdown-expansion.px]="dropdownExpansion"
    cdkDrag>
    <form class="add-task-modal__form modal-form" [formGroup]="addTaskForm" (ngSubmit)="onSubmit()">
        <div class="modal-header add-task-modal__header" cdkDragHandle>
            <div class="add-task-modal__headline modal-headline">
                <span class="add-task-modal__eyebrow modal-eyebrow">{{ 'TASK' | translate }}</span>
                <h4 class="modal-title add-task-modal__title modal-heading">
                    {{ (iIsBulkEdit ? 'BULK_EDIT_TASKS' : (id === null ? 'ADD_TASK' : 'EDIT_TASK')) | translate }}
                </h4>
            </div>
            <button type="button" class="add-task-modal__close modal-close" [attr.aria-label]="'CLOSE' | translate" (click)="activeModal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="modal-body add-task-modal__body">
            <div *ngIf="iIsBulkEdit" class="add-task-modal__field modal-field">
                <p class="add-task-modal__bulk-note">
                    {{ 'APPLY_CHANGES_TO_SELECTED_TASKS' | translate:{ count: bulkEditTasks.length } }}
                </p>
            </div>

            <ng-container *ngIf="!iIsBulkEdit; else bulkEditBody">
            <div class="add-task-modal__top-row">
                <div class="add-task-modal__field add-task-modal__field--title modal-field">
                    <label class="add-task-modal__label modal-label" for="task-title">{{ 'TASK_TITLE' | translate }}</label>
                    <ng-select *ngIf="id === null"
                        id="task-title"
                        [placeholder]="'TASK_TITLE' | translate"
                        [items]="sortedTaskTemplates"
                        bindLabel="title"
                        bindValue="title"
                        notFoundText=""
                        [clearable]="true"
                        (search)="onTitleSearch($event)"
                        (blur)="commitTypedTitle()"
                        formControlName="title"
                        class="no-disabled-dropdown add-task-modal__select modal-select"
                        [ngClass]="{ 'is-invalid': submitted && f.title.errors }">
                    </ng-select>
                    <input *ngIf="id !== null"
                        id="task-title"
                        type="text"
                        class="form-control add-task-modal__control modal-control"
                        formControlName="title"
                        [ngClass]="{ 'is-invalid': submitted && f.title.errors }"
                        [placeholder]="'TASK_TITLE' | translate">
                    <div *ngIf="submitted && f.title.errors" class="invalid-feedback add-task-modal__feedback modal-feedback">
                        <div *ngIf="f.title.errors.required">{{ 'TITLE_IS_REQUIRED' | translate }}</div>
                    </div>
                </div>

                <div class="add-task-modal__field add-task-modal__field--priority modal-field">
                    <label class="add-task-modal__label modal-label" for="task-priority">{{ 'PRIORITY' | translate }}</label>
                    <ng-select
                        id="task-priority"
                        class="add-task-modal__priority modal-select"
                        formControlName="priority"
                        [clearable]="false"
                        [searchable]="false">
                        <ng-option *ngFor="let p of TASK_PRIORITY" [value]="p.value">{{ p.title | translate }}</ng-option>
                    </ng-select>
                </div>
            </div>

            <div class="add-task-modal__field add-task-modal__field--description modal-field">
                    <label class="add-task-modal__label modal-label" for="task-description">{{ 'DETAILS' | translate }}</label>
                <textarea id="task-description"
                    class="form-control add-task-modal__control add-task-modal__control--textarea modal-control modal-control--textarea"
                    rows="4"
                    formControlName="description"
                    [ngClass]="{ 'is-invalid': submitted && f.description.errors }"
                    [placeholder]="'ENTER_TASK_DETAILS' | translate"></textarea>
                <div *ngIf="submitted && f.description.errors" class="invalid-feedback add-task-modal__feedback modal-feedback">
                    <div *ngIf="f.description.errors.required">{{ 'TEXT_IS_REQUIRED' | translate }}</div>
                </div>
            </div>

            <div class="add-task-modal__settings-row add-task-modal__settings-row--client-campaign">
                <div class="add-task-modal__setting-card add-task-modal__setting-card--client">
                    <label class="add-task-modal__setting-label modal-label" for="clientId">
                        <span>{{ 'CLIENT' | translate }}</span>
                        <a *ngIf="addTaskForm.get('clientId')?.value" target="_blank" href="/pages/client-details/{{addTaskForm.get('clientId')?.value}}">
                            <i class="fas fa-external-link-alt"></i>
                        </a>
                    </label>
                    <div class="add-task-modal__setting-control modal-field">
                        <ng-select id="clientId"
                            [placeholder]="'NONE' | translate"
                            [items]="allClients"
                            bindLabel="fullName"
                            bindValue="id"
                            formControlName="clientId"
                            (open)="onDropdownOpen()"
                            (close)="onDropdownClose()"
                            class="modal-select">
                        </ng-select>
                    </div>
                </div>

                <div class="add-task-modal__setting-card add-task-modal__setting-card--campaign">
                    <label class="add-task-modal__setting-label modal-label" for="campaignId">
                        <span>{{ 'CAMPAIGN' | translate }}</span>
                        <a *ngIf="addTaskForm.get('campaignId')?.value" target="_blank" href="/pages/campaign-details/{{addTaskForm.get('campaignId')?.value}}">
                            <i class="fas fa-external-link-alt"></i>
                        </a>
                    </label>
                    <div class="add-task-modal__setting-control modal-field">
                        <ng-select id="campaignId"
                            [placeholder]="'NONE' | translate"
                            [items]="fiteredCampaigns"
                            bindLabel="name"
                            bindValue="id"
                            formControlName="campaignId"
                            (open)="onDropdownOpen()"
                            (close)="onDropdownClose()"
                            class="modal-select">
                        </ng-select>
                    </div>
                </div>
            </div>

            <div class="add-task-modal__settings-grid">
                <div class="add-task-modal__setting-card">
                    <label class="add-task-modal__setting-label modal-label" for="assignedUserId">{{ 'ASSIGNED_USER' | translate }}</label>
                    <div class="add-task-modal__setting-control modal-field">
                        <ng-select id="assignedUserId"
                            [placeholder]="'NONE' | translate"
                            [items]="allUsers"
                            bindLabel="fullName"
                            bindValue="id"
                            formControlName="assignedUserId"
                            (open)="onDropdownOpen()"
                            (close)="onDropdownClose()"
                            class="modal-select">
                        </ng-select>
                    </div>
                </div>

                <div class="add-task-modal__setting-card">
                    <label class="add-task-modal__setting-label modal-label" for="dueDate">{{ 'DUE_DATE' | translate }}</label>
                    <div class="add-task-modal__setting-control modal-field">
                        <input id="dueDate"
                            class="form-control add-task-modal__control modal-control"
                            [ngClass]="{ 'is-invalid': submitted && f.dueDate.errors }"
                            mwlFlatpickr
                            [altInputClass]="'datetime add-task-modal__control add-task-modal__control--date'"
                            [altInput]="true"
                            [convertModelValue]="true"
                            formControlName="dueDate" />
                        <div *ngIf="submitted && f.dueDate.errors" class="invalid-feedback add-task-modal__feedback modal-feedback">
                            <div *ngIf="f.dueDate.errors.required">{{ 'REQUIRED' | translate }}</div>
                        </div>
                    </div>
                </div>
            </div>
            </ng-container>

            <ng-template #bulkEditBody>
                <div class="add-task-modal__bulk-grid">
                    <div class="add-task-modal__field modal-field">
                        <label class="add-task-modal__label modal-label">
                            <input type="checkbox" formControlName="applyAssignedUser">
                            {{ 'CHANGE_ASSIGNED_USER' | translate }}
                        </label>
                        <div class="add-task-modal__setting-control modal-field">
                            <ng-select
                                id="assignedUserId"
                                [placeholder]="'NONE' | translate"
                                [items]="allUsers"
                                bindLabel="fullName"
                                bindValue="id"
                                formControlName="assignedUserId"
                                (open)="onDropdownOpen()"
                                (close)="onDropdownClose()"
                                class="modal-select">
                            </ng-select>
                        </div>
                    </div>

                    <div class="add-task-modal__field modal-field">
                        <label class="add-task-modal__label modal-label">
                            <input type="checkbox" formControlName="applyDueDate">
                            {{ 'CHANGE_DUE_DATE' | translate }}
                        </label>
                        <div class="add-task-modal__setting-control modal-field">
                            <input id="dueDate"
                                class="form-control add-task-modal__control modal-control"
                                mwlFlatpickr
                                [altInputClass]="'datetime add-task-modal__control add-task-modal__control--date'"
                                [altInput]="true"
                                [convertModelValue]="true"
                                formControlName="dueDate" />
                        </div>
                    </div>
                </div>
            </ng-template>
        </div>

        <div *ngIf="iCanEdit" class="modal-footer add-task-modal__footer" cdkDragHandle>
            <div class="add-task-modal__actions modal-actions">
                <div class="add-task-modal__actions-primary">
                    <button class="blue-button add-task-modal__button add-task-modal__button--save modal-button" type="submit">{{ iIsBulkEdit ? ('APPLY_CHANGES' | translate) : ('SAVE' | translate) }}</button>
                    <button *ngIf="!iIsBulkEdit && id !== null && iCanDelete" type="button" class="add-task-modal__button add-task-modal__button--delete modal-button" (click)="deleteTask()">{{ 'DELETE' | translate }}</button>
                </div>
                <div class="add-task-modal__actions-secondary">
                    <button *ngIf="!iIsBulkEdit && id !== null && (f.isCompleted.value === null || f.isCompleted.value === false)" type="button" class="add-task-modal__button add-task-modal__button--complete modal-button" (click)="markAsComplete()">{{ 'MARK_AS_COMPLETE' | translate }}</button>
                </div>
            </div>
        </div>
    </form>
</div>
